"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectNotificationGeneralUnread = exports.selectNotificationCounts = exports.selectMessages = exports.getMessagesPanelFetchItems = exports.getMessagesPanelPagination = exports.getMessagesPanelHasMore = exports.getMessagesPageFetchItems = exports.getMessagesPagePagination = exports.getMessagesPageHasMore = exports.getMessagesIds = exports.getMessages = void 0;
const reselect_1 = require("reselect");
const slices_1 = require("../../utils/@reduxjs/slices");
const slice_1 = require("./slice");
const getMessages = (state) => state.messagesProvider.data.entries || slice_1.initialState.data.entries;
exports.getMessages = getMessages;
const getMessagesIds = (state, layoutType) => state.messagesProvider.layout[layoutType].ids ||
    slice_1.initialState.layout[layoutType].ids;
exports.getMessagesIds = getMessagesIds;
// Page
const getMessagesPageHasMore = (state) => {
    var _a;
    return (_a = state.messagesProvider.layout.notificationsPage.hasMore) !== null && _a !== void 0 ? _a : slice_1.initialState.layout.notificationsPage.hasMore;
};
exports.getMessagesPageHasMore = getMessagesPageHasMore;
const getMessagesPagePagination = (state) => state.messagesProvider.layout.notificationsPage.pagination ||
    slice_1.initialState.layout.notificationsPage.pagination;
exports.getMessagesPagePagination = getMessagesPagePagination;
const getMessagesPageFetchItems = (state) => state.messagesProvider.layout.notificationsPage.fetchItems ||
    slice_1.initialState.layout.notificationsPage.fetchItems;
exports.getMessagesPageFetchItems = getMessagesPageFetchItems;
// Page end
// Panel
const getMessagesPanelHasMore = (state) => {
    var _a;
    return (_a = state.messagesProvider.layout.notificationsPanel.hasMore) !== null && _a !== void 0 ? _a : slice_1.initialState.layout.notificationsPanel.hasMore;
};
exports.getMessagesPanelHasMore = getMessagesPanelHasMore;
const getMessagesPanelPagination = (state) => state.messagesProvider.layout.notificationsPanel.pagination ||
    slice_1.initialState.layout.notificationsPanel.pagination;
exports.getMessagesPanelPagination = getMessagesPanelPagination;
const getMessagesPanelFetchItems = (state) => state.messagesProvider.layout.notificationsPanel.fetchItems ||
    slice_1.initialState.layout.notificationsPanel.fetchItems;
exports.getMessagesPanelFetchItems = getMessagesPanelFetchItems;
// Panel end
exports.selectMessages = (0, reselect_1.createSelector)([exports.getMessagesIds, exports.getMessages], (ids, messagesList) => (0, slices_1.getValues)(ids, messagesList));
const selectNotificationCounts = (state) => state.messagesProvider.data.counts.data || slice_1.initialState.data.counts.data;
exports.selectNotificationCounts = selectNotificationCounts;
exports.selectNotificationGeneralUnread = (0, reselect_1.createSelector)(exports.selectNotificationCounts, (counts) => counts.broadcast_unread + counts.direct_unread);
//# sourceMappingURL=selectors.js.map